import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import Break from '../../../../../assets/icons/Break';
import * as css from './ActionsBar.css';

interface ActionsBarProps {
    onAddItem: () => void;
    onAddBreak: () => void;
}

function ActionsBar({onAddItem, onAddBreak}: ActionsBarProps) {
    const {t} = useTranslation('timetable');
    return (
        <css.actionsBar>
            <Button variant="brand" size="chip" onClick={onAddItem}>{t('addItemGrid')}</Button>
            <Button variant="neutral" size="chip" iconStart={<Break />} onClick={onAddBreak}>{t('addBreak')}</Button>
        </css.actionsBar>
    );
}

export default ActionsBar;
